import React, { useState } from 'react'
import { Radio } from 'antd';
import TractorSearch from './TractorSearch';
import ImplementsSearch from './ImplementsSearch';
import AccessoriesSearch from './AccessoriesSearch';
import { SVG_BACKGROUND } from '../../constants'


function AdvanceSearch() {
    const [category, setCategory] = useState("T");
    const changeCategory = (e) => {
        setCategory(e.target.value)
    }
  return (
        <div>
            <div className="absolute hidden md:block" style={{top: "6rem", zIndex: 99, left: '8rem'}}>
                <div className="shadow-lg overflow-hidden w-full bg-white rounded-lg">
                    <div className="px-8 py-4 m-4">
                        <div>
                            <span className="text-3xl text-purple-700 font-bold">
                                Search for
                                {category === "T" ? (` Tractors`): null}
                                {category === "I" ? (` Implements`): null}
                                {category === "A" ? (` Accessories`): null}
                            </span>
                        </div>
                        <div className="mt-3">
                            <Radio.Group defaultValue="T" onChange={changeCategory} buttonStyle="solid" size="large">
                                <Radio.Button value="T">Tractors</Radio.Button>
                                <Radio.Button value="I">Implements</Radio.Button>
                                <Radio.Button value="A">Accessories</Radio.Button>
                            </Radio.Group>
                        </div>
                        <div className="">
                            {category === "T" ? (
                                <div>
                                    <TractorSearch />
                                </div>
                            ): null}

                            {category === "I" ? (
                                <ImplementsSearch />
                            ): null}

                            {category === "A" ? (
                                <AccessoriesSearch />
                            ): null}

                        </div>
                    </div>
                </div>
            </div>


            <div className="md:hidden">
                <div className="rounded shadow-lg w-full bg-white -mt-2">
                    <div className="px-8 py-4">
                        <div className="mt-4">
                            <span className="text-3xl text-purple-700 font-bold">
                                Search for
                                {category === "T" ? (` Tractors`): null}
                                {category === "I" ? (` Implements`): null}
                                {category === "A" ? (` Accessories`): null}
                            </span>
                        </div>
                        <div className="mt-3">
                            <Radio.Group defaultValue="T" onChange={changeCategory} buttonStyle="solid" size="large">
                                <Radio.Button value="T">Tractors</Radio.Button>
                                <Radio.Button value="I">Implements</Radio.Button>
                                <Radio.Button value="A">Accessories</Radio.Button>
                            </Radio.Group>
                        </div>
                        <div className="">
                            {category === "T" ? (
                                <div>
                                    <TractorSearch />
                                </div>
                            ): null}

                            {category === "I" ? (
                                <ImplementsSearch />
                            ): null}

                            {category === "A" ? (
                                <AccessoriesSearch />
                            ): null}

                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
}

export default AdvanceSearch;
